export default {"src":"/_next/static/media/picto-stab-hover.e0f4abdb.svg","height":24,"width":22,"blurWidth":0,"blurHeight":0};